import { supabase } from "@/integrations/supabase/client";

export const autoLoginInDev = async () => {
  // Check if we're in development mode (Lovable preview)
  const isDev = window.location.hostname.includes('lovable.app') || 
               window.location.hostname === 'localhost';
  
  if (!isDev) return false;

  try {
    // Check if already logged in
    const { data: { session } } = await supabase.auth.getSession();
    if (session) return true;

    // Try to sign in the dev user automatically
    const { data, error } = await supabase.auth.signInWithPassword({
      email: 'bastiaanweide@gmail.com',
      password: 'password123'
    });
    
    if (!error && data.session) {
      console.log("Auto-login successful for development");
      return true;
    }
  } catch (err) {
    console.log("Auto-login failed, proceeding with normal auth flow");
  }
  
  return false;
};